<template>
  <span
    class="msc-help-tip show-hand"
    v-b-popover.hover="tip"
    role="button"
    tabindex="0"
    :aria-label="tip"
    @click="$emit('click')"
    @keydown.enter.prevent="$emit('click')"
    @keydown.space.prevent="$emit('click')"
  >
    <span class="msc-help-tip__glyph" aria-hidden="true">?</span>
  </span>
</template>

<script>
export default {
  name: 'help-tip',
  props: {
    tip: {
      type: String,
      required: true,
    },
  },
};
</script>
